import React from "react";
import { QRCodeSVG } from "qrcode.react";
import Navbar from "@/components/Navbar";
import { ScanLine } from "lucide-react";

export default function QRCodePage() {
  const loginUrl = typeof window !== "undefined" ? `${window.location.origin}/login` : "/login";

  return (
    <div className="min-h-screen bg-white">
      <Navbar minimal />
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-64px)] px-6 py-16">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="text-xs font-semibold uppercase tracking-widest text-orange-600 mb-3">Quick access</div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">Scan to Access LeaderSim</h1>
          <p className="mt-3 text-slate-500 max-w-sm mx-auto">
            Point your phone camera at this code to open the LeaderSim participant portal instantly.
          </p>
        </div>

        {/* QR Code */}
        <div className="bg-white rounded-3xl border-4 border-[#EA580C] p-7 shadow-2xl shadow-orange-100"
          data-testid="qr-code-display"
        >
          <QRCodeSVG
            value={loginUrl}
            size={220}
            fgColor="#0F172A"
            bgColor="#FFFFFF"
            level="M"
            marginSize={1}
          />
        </div>

        {/* Label */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center gap-2 bg-slate-900 text-white rounded-full px-6 py-3">
            <ScanLine className="w-4 h-4 text-orange-400" strokeWidth={1.75} />
            <span className="font-semibold text-sm">Scan to Access LeaderSim</span>
          </div>
          <div className="mt-3 text-slate-400 text-xs font-mono">{loginUrl}</div>
        </div>

        {/* Branding strip */}
        <div className="mt-10 flex items-center gap-6 text-sm text-slate-400">
          <div className="w-8 h-px bg-slate-200" />
          <span>Powered by</span>
          <img
            src="https://customer-assets.emergentagent.com/job_roleplay-mentor-3/artifacts/lkmqxka2_Emergence%20Logo%20Black%2080x265-%20Original.jpg"
            alt="Emergence"
            className="h-5 w-auto object-contain opacity-60"
          />
          <div className="w-8 h-px bg-slate-200" />
        </div>
      </div>
    </div>
  );
}
